import script from "./AppGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppGrid.vue?vue&type=script&setup=true&lang=ts"

import "./AppGrid.vue?vue&type=style&index=0&id=4c3fb33b&lang=scss"

const __exports__ = script;

export default __exports__